import React from 'react';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { BetAmountAutoCashOutWr } from './betAmountAutoCashOut';
import { StartAutoPlay } from '../../../../components/common/bettingPart';
import { BaseBetIncreaseSection } from './baseBetIncreaseSection';
import { StopAutoRound } from './stopRound';
import { autoPlayBetStore } from '../../../../store';

export const AutoplaySection = ({ t, handleOpenNumPad }) => {
  const limits = gameConfigStore.limits;
  return (
    <div className='bet-sec-container-main'>
      {/* Add for bet-sec-container class or attribute // disabled // to disable bet-sec-container-inner and bet-option-btn */}
      <div className={`bet-sec-container ${autoPlayBetStore.isStartAutoPlay ? 'disabled' : ''}`}>
        {/* Add for bet-sec-container-inner class or attribute // disabled // to disable it */}
        <div className='bet-sec-container-inner'>
          <BetAmountAutoCashOutWr t={t} limits={limits} handleOpenNumPad={handleOpenNumPad} />
          <BaseBetIncreaseSection t={t} handleOpenNumPad={handleOpenNumPad} />
          <StopAutoRound t={t} limits={limits} handleOpenNumPad={handleOpenNumPad} />
        </div>
        <StartAutoPlay t={t} />
      </div>
    </div>
  );
};
